import { getArrayApiClient } from 'adapter/out/client/apiClient';
import { parseCreateAutomationCriteria } from 'adapter/out/client/automation/createAutomationApiClient';
import { ReportSimulation } from 'domain/entity/reportSimulation';
import { CreateOrPreviewAutomationCriteria } from 'use-case/automation/create/createAutomationCriteria';

const simulateReportsApiClient = getArrayApiClient(
    () => `dashboards/automations/simulate/reports`,
    ReportSimulation,
    (clientCriteria: CreateOrPreviewAutomationCriteria) => ({
        method: 'POST',
        body: JSON.stringify(parseCreateAutomationCriteria(clientCriteria)),
        headers: { 'Content-Type': 'application/json' },
    })
);

export default simulateReportsApiClient;
